module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agree":"Agree with <a href=\u0027{url}\u0027>politics</a>","button":{"activate":"Activate","pay":"Pay {amount}","cancel":"Cancel","active":"Active"},"currency":{"RUB":"RUB"}}}')
  delete Component.options._Ctor
}
